
import { useEffect, useState, useCallback } from 'react';
import './App.css';

function App() {
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('Checking backend...');
  const [database, setDatabase] = useState('checking');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const [saving, setSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');

  const [users, setUsers] = useState([]);

  // Check backend
  const checkAPI = useCallback(async () => {
    try {
      const response = await fetch('/api/health', {
        cache: 'no-store'
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus('connected');
        setMessage(data.message);
        setDatabase(
          data.database === 'Connected'
            ? 'connected'
            : 'disconnected'
        );
      } else {
        setStatus('error');
        setMessage(data.message || 'Backend error');
        setDatabase('disconnected');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Unable to connect to backend');
      setDatabase('unknown');
    }
  }, []);

  // Get users from MongoDB
  const getUsers = useCallback(async () => {
    try {
      const response = await fetch('/api/users');
      const data = await response.json();

      if (response.ok && data.success) {
        setUsers(data.data);
      }
    } catch (error) {
      console.error('Get Users Error:', error);
    }
  }, []);

  // Save user to MongoDB
  const addUser = async (e) => {
    e.preventDefault();

    setSaving(true);
    setSaveMessage('');

    try {
      const response = await fetch('/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email
        })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Unable to save user');
      }

      setSaveMessage('User saved successfully!');

      setName('');
      setEmail('');

      // Refresh users
      await getUsers();

    } catch (error) {
      setSaveMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    checkAPI();
    getUsers();

    const interval = setInterval(checkAPI, 30000);

    return () => clearInterval(interval);
  }, [checkAPI, getUsers]);

  return (
    <div className="container">

      <h1>Welcome to Esha Astra</h1>

      <p>React frontend is running!</p>

      {/* Backend Status */}
      <div className={`status-card ${status}`}>
        <h2>Backend API Status</h2>
        <h3>
          {status === 'checking' && 'Checking...'}
          {status === 'connected' && 'Connected'}
          {status === 'error' && 'Connection Failed'}
        </h3>

        <p>{message}</p>

        <h3>MongoDB Status</h3>

        <p>
          {database === 'connected' && 'Database Connected'}
          {database === 'disconnected' && 'Database Disconnected'}
          {database === 'unknown' && 'Database unavailable'}
          {database === 'checking' && 'Checking database...'}
        </p>

        <button onClick={checkAPI}>
          Check Connection
        </button>
      </div>

      {/* Add User Form */}
      <div className="status-card">
        <h2>Add User</h2>

        <form onSubmit={addUser}>

          <div>
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save User'}
          </button>

        </form>

        {saveMessage && (
          <p>{saveMessage}</p>
        )}
      </div>

      {/* Display Users */}
      <div className="status-card">
        <h2>Saved Users</h2>

        {users.length === 0 ? (
          <p>No users found.</p>
        ) : (
          users.map((user) => (
            <div key={user._id}>
              <p><strong>Name:</strong> {user.name}</p>
              <p><strong>Email:</strong> {user.email}</p>
              <hr />
            </div>
          ))
        )}

      </div>

    </div>
  );
}

export default App;
